import * as React from 'react';
import { css } from '@emotion/core';
import { Report } from './models';
import ReportCard from './ReportCard';
import { Language } from '../../localization/models';
import { FLEX_COLUMN, FLEX_CENTERED } from '../../layout/flexBox';
import Msg from '../../localization/Msg';
import { Str } from '../../localization/translationKeys';


const styles = {
  card: css`
    flex-basis: 100%;
    margin-bottom: 5px;
  `,
  noReports:  css`
    text-align: center;
  `,
};


type Props = {
  reports: Report[];

  showShareScoresBtn: (report: Report) => boolean;
  showDownloadReportBtn: (report: Report) => boolean;
  setReport: (report: Report) => void;
  onClickShareScoresBtn: (report: Report) => void;
  getLanguage: (languageId: number) => Language;

  className?: string;
};


/**
 * ReportCards: a component that
 */
const ReportCards: React.FC<Props> = (
  {
    reports,
    showShareScoresBtn,
    showDownloadReportBtn,
    setReport,
    onClickShareScoresBtn,
    getLanguage,
    className,
  },
) => (
  <div className={className}>
    {
      reports!.map(report => (
        // eslint-disable-next-line react/jsx-no-undef
        <ReportCard
          report={report}
          showDownloadReportBtn={showDownloadReportBtn(report)}
          showShareScoresBtn={showShareScoresBtn(report)}
          setReport={() => setReport(report)}
          onClickShareScoresBtn={() => onClickShareScoresBtn(report)}
          language={getLanguage(report.languageId)?.nativeName ?? ''}
          css={styles.card}
        />
      ))
    }
    {
      !reports.length && (
        <div css={[FLEX_COLUMN, FLEX_CENTERED]}>
          <Msg str={Str.NoProjects} css={styles.noReports} />
        </div>
      )
    }
  </div>
);

export default ReportCards;
